// @ts-nocheck
/* eslint-disable */
import React, { useState, useMemo, useEffect } from 'react';
import useAppStore from '../store/appStore';
import { PreislistenEintrag } from '../store/types';
import { berechneRuecklage } from '../utils/paketRuecklage';
import { isSoloModeActive } from '../utils/soloMode';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

// WICHTIG: Firebase Imports für die KI-Funktion!
import { getFunctions, httpsCallable } from 'firebase/functions';

// 💉 FIX: Importiere den Kalkulations-Selector für exakte Skalierungs-Berechnungen
import { useCalculationsSelector } from '../store/selectors/calculations';
import { formatMoney, currencyLabel } from '../utils/currencyFormatter';

const Styles = () => (
    <style>{`
        /* --- NOBLE SLATE & CARBON WEAVE --- */
        .font-numeric { font-family: 'JetBrains Mono', monospace; font-variant-numeric: tabular-nums; }
        
        .carbon-weave-bg {
            background-color: #111;
            background-image:
                radial-gradient(circle at 100% 150%, #111 24%, #1a1a1a 24%, #1a1a1a 28%, #111 28%, #111 36%, #1a1a1a 36%, #1a1a1a 40%, transparent 40%, transparent),
                radial-gradient(circle at 0 150%, #111 24%, #1a1a1a 24%, #1a1a1a 28%, #111 28%, #111 36%, #1a1a1a 36%, #1a1a1a 40%, transparent 40%, transparent),
                radial-gradient(circle at 50% 100%, #1a1a1a 10%, #111 10%, #111 23%, #1a1a1a 23%, #1a1a1a 30%, #111 30%, #111 43%, #1a1a1a 43%, #1a1a1a 50%, #111 50%, #111 63%, #1a1a1a 63%, #1a1a1a 71%, transparent 71%, transparent),
                radial-gradient(circle at 100% 50%, #1a1a1a 5%, #111 5%, #111 15%, #1a1a1a 15%, #1a1a1a 20%, #111 20%, #111 29%, #1a1a1a 29%, #1a1a1a 34%, #111 34%, #111 44%, #1a1a1a 44%, #1a1a1a 49%, transparent 49%, transparent),
                radial-gradient(circle at 0 50%, #1a1a1a 5%, #111 5%, #111 15%, #1a1a1a 15%, #1a1a1a 20%, #111 20%, #111 29%, #1a1a1a 29%, #1a1a1a 34%, #111 34%, #111 44%, #1a1a1a 44%, #1a1a1a 49%, transparent 49%, transparent);
            background-size: 20px 20px;
        }

        .carbon-panel {
            position: relative;
            border-radius: 1rem;
            border: 1px solid #222;
            box-shadow: 0 30px 60px -15px rgba(0,0,0,1), inset 0 2px 5px rgba(255,255,255,0.02);
            overflow: hidden;
        }

        .carbon-panel::after {
            content: '';
            position: absolute;
            inset: 0;
            background: linear-gradient(to bottom, transparent, rgba(0,0,0,0.6));
            pointer-events: none;
            z-index: 1;
        }

        .carbon-content {
            position: relative;
            z-index: 10;
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
        }

        .print-only { display: none !important; }

        /* LIGHT MODE: Warm-Platin-Overrides (Dark bleibt exakt wie oben definiert) */
        html:not(.dark) .carbon-weave-bg {
            background-color: var(--pe-bg-primary);
            background-image: none;
        }
        html:not(.dark) .carbon-panel {
            border: 1px solid var(--pe-border-subtle);
            box-shadow: 0 20px 40px -20px rgba(28, 25, 23, 0.15);
        }
        html:not(.dark) .carbon-panel::after {
            background: none;
        }

        @media print {
            .no-print { display: none !important; }
            .print-only { display: table-row !important; }

            @page {
                size: A4 portrait;
                margin: 12mm;
            }
            
            /* RADIKAL-FIX: Sprengt alle Fesseln für saubere Seitenumbrüche */
            html, body {
                width: 100% !important;
                max-width: none !important;
                height: auto !important;
                min-height: 100% !important;
                overflow: visible !important;
                background-color: white !important;
                color: black !important;
                margin: 0 !important;
                padding: 0 !important;
            }

            /* Befreit das Modal aus seiner fixierten Position — volle Seitenbreite */
            .fixed {
                position: static !important;
                display: block !important;
                width: 100% !important;
                max-width: none !important;
                background: white !important;
                padding: 0 !important;
                inset: auto !important;
                backdrop-filter: none !important;
                overflow: visible !important;
                justify-content: flex-start !important;
                align-items: stretch !important;
            }

            #preisliste-print-container,
            .carbon-panel,
            .carbon-content {
                position: static !important;
                display: block !important;
                width: 100% !important;
                max-width: none !important;
                min-width: 100% !important;
                height: auto !important;
                max-height: none !important;
                overflow: visible !important;
                box-shadow: none !important;
                border: none !important;
                border-radius: 0 !important;
                padding: 0 !important;
                margin: 0 !important;
                background: white !important;
                background-image: none !important;
            }

            .carbon-panel::after { display: none !important; }

            /* Erlaubt der Tabelle, unendlich lang zu werden — volle Breite */
            .print-scroll-area {
                position: static !important;
                display: block !important;
                width: 100% !important;
                max-width: none !important;
                height: auto !important;
                max-height: none !important;
                overflow: visible !important;
                padding: 0 !important;
                margin: 0 !important;
            }

            /* Dunkle Screen-Wrapper-Borders beim Druck entfernen */
            #preisliste-print-container .border,
            #preisliste-print-container .rounded-b-xl,
            #preisliste-print-container .rounded-t-xl,
            #preisliste-print-container .mb-10 {
                width: 100% !important;
                max-width: none !important;
                border: none !important;
                border-radius: 0 !important;
                box-shadow: none !important;
                background: transparent !important;
                overflow: visible !important;
            }

            #preisliste-print-container * {
                color: black !important;
                text-shadow: none !important;
                background: transparent !important;
                max-width: none !important;
            }
            
            /* DIE LÖSUNG FÜR DIE TANZENDEN SPALTEN: Fixed Layout & harte %-Werte */
            .print-table { 
                width: 100% !important; 
                max-width: none !important;
                border-collapse: collapse; 
                margin-bottom: 2rem; 
                page-break-inside: auto; 
                table-layout: fixed !important; 
            }
            .print-table tr { page-break-inside: avoid; page-break-after: auto; }
            .print-table th { background-color: #f3f4f6 !important; font-weight: bold; padding: 8px; border-bottom: 2px solid black !important; -webkit-print-color-adjust: exact; }
            .print-table td { padding: 8px; border-bottom: 1px solid #e5e7eb !important; word-wrap: break-word; }
            
            /* Zwingende Spaltenbreiten für absolute Symmetrie über alle Tabellen hinweg */
            .print-col-1 { width: 55% !important; text-align: left !important; }
            .print-col-2 { width: 20% !important; text-align: center !important; white-space: nowrap !important; }
            .print-col-3 { width: 25% !important; text-align: right !important; white-space: nowrap !important; }
            
            h1.print-title { text-align: center; margin-bottom: 2rem; font-size: 24pt; border-bottom: 3px solid black; padding-bottom: 10px; display: block !important; width: 100% !important; }
            h2.print-category { font-size: 16pt; margin-top: 1.5rem; margin-bottom: 0.5rem; display: block !important; border-bottom: 1px solid black; padding-bottom: 4px; page-break-after: avoid; width: 100% !important; }
            .paket-print-only { display: block !important; }

            /* BRANDING REGELN */
            #system-screen-title-pricing-master { display: none !important; }
            .print-header-branding { display: block !important; width: 100% !important; border-bottom: 2px solid black; padding-bottom: 1rem; margin-bottom: 2.5rem; }
            
            /* Universal-Collapse für alle anderen UI-Elemente im Hintergrund */
            body * { visibility: hidden; }
            body *:not(#preisliste-print-container):not(#preisliste-print-container *) {
                height: 0 !important;
                min-height: 0 !important;
                margin: 0 !important;
                padding: 0 !important;
                border: 0 !important;
                overflow: visible !important;
            }
            #preisliste-print-container, #preisliste-print-container * {
                visibility: visible;
            }
        }
    `}</style>
);

function RuecklageAnzeige({ pct, betrag, formatCurrency }: { pct: number | undefined | null; betrag?: number; formatCurrency: (n: number | undefined) => string }) {
    if (pct === undefined || pct === null || Number.isNaN(Number(pct))) {
        return <span className="font-bold text-lg text-pe-muted">---</span>;
    }
    const n = Number(pct);
    let badge: React.ReactNode;
    if (n < 0) {
        badge = <span className="inline-flex items-center rounded-md px-2 py-0.5 font-black text-lg tabular-nums bg-red-100 text-red-800 border border-red-400 dark:bg-red-950/40 dark:text-red-400 dark:border-red-500/50">{n.toFixed(1)}%</span>;
    } else if (n >= 10) {
        badge = <span className="font-bold text-lg tabular-nums text-emerald-700 dark:text-green-500">{n.toFixed(1)}%</span>;
    } else {
        badge = <span className="inline-flex items-center rounded-md px-2 py-0.5 font-black text-lg tabular-nums bg-amber-200 text-amber-950 border border-amber-500 dark:bg-yellow-500/20 dark:text-yellow-300 dark:border-yellow-400/70" title="Rücklage unter 10 % — bitte prüfen">{n.toFixed(1)}%</span>;
    }
    return (
        <div className="flex flex-col items-end">
            {badge}
            {betrag !== undefined && <div className="text-sm text-pe-muted dark:text-gray-400 font-medium mt-1">{formatCurrency(betrag)}</div>}
        </div>
    );
}

function MaterialAnzeige({ grams, mat, dev, formatCurrency, mengeLabel = 'Menge' }: { grams?: number; mat?: number; dev?: number; formatCurrency: (n: number | undefined) => string; mengeLabel?: string }) {
    const g = Number(grams) || 0;
    const m = Number(mat) || 0;
    const d = Number(dev) || 0;
    if (g <= 0 && m <= 0 && d <= 0) {
        return <span className="text-stone-400 dark:text-gray-600">-</span>;
    }
    return (
        <div className="flex flex-col gap-0.5 items-end no-print">
            {g > 0 && <span className="whitespace-nowrap text-yellow-700 dark:text-yellow-500/90 text-xs font-medium">{mengeLabel}: {g}&nbsp;g</span>}
            {(m > 0 || g > 0) && <span className="whitespace-nowrap text-yellow-700 dark:text-yellow-500/90 text-xs font-medium">Mat. {formatCurrency(m)}</span>}
            {d > 0 && <span className="whitespace-nowrap text-blue-700 dark:text-blue-400/90 text-xs font-medium">Geräte: {formatCurrency(d)}</span>}
        </div>
    );
}

export default function PreislistenManager({ onClose }: { onClose: () => void }) {
    const { clientData, setClientData, settings } = useAppStore();
    const storeCalc = useCalculationsSelector();
    const currencyCode = currencyLabel(
        settings?.country?.currency || storeCalc?.currencyCode,
        (clientData as any)?.land || (settings as any)?.selectedCountryId
    );
    
    const preisliste: PreislistenEintrag[] = useMemo(() => clientData?.preisliste || [], [clientData?.preisliste]);
    
    const [editingId, setEditingId] = useState<string | null>(null);
    const [openPackageId, setOpenPackageId] = useState<string | null>(null);
    const [editForm, setEditForm] = useState<Partial<PreislistenEintrag>>({});
    
    const [editMetrics, setEditMetrics] = useState({ nettoMultiplier: 1, fixedCosts: 0 });

    const [isAnalyzing, setIsAnalyzing] = useState(false);
    const [isPdfSaving, setIsPdfSaving] = useState(false);
    const [aiReport, setAiReport] = useState<{
        summary: string;
        findings: { type: 'error'|'warning'|'success'; title: string; message: string }[];
    } | null>(null);

    const groupedPreisliste = useMemo(() => {
        const groups: Record<string, PreislistenEintrag[]> = {};
        preisliste.forEach((item: any) => {
            const kat = item.kategorie || 'Unsortiert';
            if (!groups[kat]) groups[kat] = [];
            groups[kat].push(item);
        });
        return groups;
    }, [preisliste]);

    const formatCurrency = (val: number | undefined) => {
        if (val === undefined || isNaN(val)) return formatMoney(0, currencyCode);
        return formatMoney(val, currencyCode);
    };
    
    const formatMinutes = (val: number | undefined) => {
        if (val === undefined || isNaN(val)) return '0';
        return val.toLocaleString('de-DE');
    };

    const ruecklageFaktoren = useMemo(() => ({
        mwstSatz: Number(storeCalc?.mwstSatz) || 0,
        gemeinkostenfaktor: Number(storeCalc?.gemeinkostenfaktor) || 0,
        unternehmerlohnAnteil: (Number(storeCalc?.unprodUnternehmerlohnPercent) || 0) / 100,
        verlustAnteil: (Number(storeCalc?.settings?.global?.Verlust_1 ?? storeCalc?.verlustPercent) || 0) / 100,
        teamStundenlohn: Number(storeCalc?.teamStundenlohn) || 0,
        lohnfortzahlungPercent: Number(storeCalc?.lohnfortzahlungPercent) || 0,
        sozialPercent: isSoloModeActive(clientData) ? 0 : (Number(storeCalc?.avgSozialabgabenPercent) || 0),
    }), [storeCalc, clientData]);

    const bewerte = (brutto: number, minuten: number, materialNetto: number, geraeteNetto: number) =>
        berechneRuecklage(ruecklageFaktoren, { brutto, minuten, materialNetto, geraeteNetto });

    const paketMitPruefung = (item: any) => {
        const teile = Array.isArray(item.packageServices) ? item.packageServices : [];
        const services = teile.map((s: any) => {
            const line = bewerte(Number(s.einzelpreisBrutto) || 0, Number(s.dauerMinuten) || 0, Number(s.materialKostenNetto) || 0, Number(s.geraeteKostenNetto) || 0);
            return { ...s, gewinn: line.gewinn, gewinnPercent: line.gewinnPercent };
        });
        const mat = teile.length
            ? teile.reduce((sum: number, s: any) => sum + (Number(s.materialKostenNetto) || 0), 0)
            : (Number(item.materialEinsatz) || 0);
        const dev = teile.length
            ? teile.reduce((sum: number, s: any) => sum + (Number(s.geraeteKostenNetto) || 0), 0)
            : (Number(item.geräteEinsatz) || 0);
        const gramm = teile.length
            ? teile.reduce((sum: number, s: any) => sum + (Number(s.materialMenge) || 0), 0)
            : (Number(item.materialMenge) || 0);
        const pack = bewerte(Number(item.finalerPreis) || 0, Number(item.gesamtDauerMinuten || item.bedienzeit) || 0, mat, dev);
        return { services, mat, dev, gramm, pack };
    };

    useEffect(() => {
        const list = clientData?.preisliste || [];
        const needs = list.some((item: any) => item?.isPackage && item.gewinnPercent === undefined && Number(item.finalerPreis) > 0);
        if (!needs) return;
        setClientData((prev: any) => ({
            ...prev,
            preisliste: (prev.preisliste || []).map((item: any) => {
                if (!item?.isPackage || item.gewinnPercent !== undefined) return item;
                const checked = paketMitPruefung(item);
                return {
                    ...item,
                    gewinn: checked.pack.gewinn,
                    gewinnPercent: checked.pack.gewinnPercent,
                    materialEinsatz: checked.mat,
                    geräteEinsatz: checked.dev,
                    packageServices: checked.services,
                };
            }),
        }));
    }, [clientData?.preisliste, ruecklageFaktoren, setClientData]);

    const resolveSalonName = () => {
        const raw =
            clientData?.firmenname ||
            clientData?.salonname ||
            clientData?.name ||
            'Salon';
        return String(raw)
            .trim()
            .replace(/[\\/:*?"<>|]+/g, '')
            .replace(/\s+/g, '_')
            .slice(0, 60) || 'Salon';
    };

    /** Heller Print-Clone → html2canvas → jsPDF (ohne Dark-UI-Capture) */
    const handleSavePdf = async () => {
        if (isPdfSaving) return;
        if (Object.keys(groupedPreisliste).length === 0) {
            alert('Die Preisliste ist leer — nichts zum Speichern.');
            return;
        }

        setIsPdfSaving(true);
        const host = document.createElement('div');
        host.setAttribute('data-preisliste-pdf-host', 'true');
        host.style.cssText = [
            'position:fixed',
            'left:-12000px',
            'top:0',
            'width:794px',
            'background:#ffffff',
            'color:#000000',
            'pointer-events:none',
            'z-index:-1',
            'padding:32px',
            'font-family:Arial,Helvetica,sans-serif',
        ].join(';');

        try {
            const salon = resolveSalonName();
            const dateIso = new Date().toISOString().slice(0, 10);
            const escapeHtml = (s: string) =>
                String(s || '')
                    .replace(/&/g, '&amp;')
                    .replace(/</g, '&lt;')
                    .replace(/>/g, '&gt;')
                    .replace(/"/g, '&quot;');

            let sectionsHtml = '';
            Object.entries(groupedPreisliste).forEach(([kategorie, items]) => {
                const rows = (items as any[])
                    .map(
                        (item) => {
                            const teile = item.isPackage && Array.isArray(item.packageServices) ? item.packageServices : [];
                            const checkedPdf = item.isPackage ? paketMitPruefung(item) : null;
                            const zeit = item.isPackage ? (item.gesamtDauerMinuten || item.bedienzeit) : item.bedienzeit;
                            const badge = item.isPackage ? ' <span style="font-size:8pt;border:1px solid #000;padding:0 4px;">Paket</span>' : '';
                            const matNote = item.isPackage && checkedPdf ? `<div style="font-size:8pt;color:#444;">Mat. ${escapeHtml(formatCurrency(checkedPdf.mat))}</div>` : '';
                            const teileRows = teile.map((s: any) => `
                    <tr>
                        <td style="padding:4px 8px 4px 20px;border-bottom:1px solid #eee;width:60%;text-align:left;font-size:9pt;">${escapeHtml(s.name || '')}<div style="color:#666;">Mat. ${escapeHtml(formatCurrency(s.materialKostenNetto || 0))}${(Number(s.materialMenge) || 0) > 0 ? ` · ${Number(s.materialMenge)} g` : ''}</div></td>
                        <td style="padding:4px 8px;border-bottom:1px solid #eee;width:20%;text-align:center;font-size:9pt;">${escapeHtml(formatMinutes(s.dauerMinuten))} Min.</td>
                        <td style="padding:4px 8px;border-bottom:1px solid #eee;width:20%;text-align:right;font-size:9pt;">${escapeHtml(formatCurrency(s.einzelpreisBrutto))}</td>
                    </tr>`).join('');
                            return `
                    <tr>
                        <td style="padding:8px;border-bottom:1px solid #e5e7eb;width:60%;text-align:left;">${escapeHtml(item.name || '')}${badge}${matNote}</td>
                        <td style="padding:8px;border-bottom:1px solid #e5e7eb;width:20%;text-align:center;">${escapeHtml(formatMinutes(zeit))} Min.</td>
                        <td style="padding:8px;border-bottom:1px solid #e5e7eb;width:20%;text-align:right;font-weight:bold;">${escapeHtml(formatCurrency(item.finalerPreis))}</td>
                    </tr>${teileRows}`;
                        }
                    )
                    .join('');

                sectionsHtml += `
                    <h2 style="font-size:16pt;margin:24px 0 8px;border-bottom:1px solid #000;padding-bottom:4px;">${escapeHtml(kategorie)}</h2>
                    <table style="width:100%;border-collapse:collapse;table-layout:fixed;margin-bottom:16px;">
                        <thead>
                            <tr>
                                <th style="padding:8px;background:#f3f4f6;border-bottom:2px solid #000;text-align:left;width:60%;">Leistung</th>
                                <th style="padding:8px;background:#f3f4f6;border-bottom:2px solid #000;text-align:center;width:20%;">Zeit</th>
                                <th style="padding:8px;background:#f3f4f6;border-bottom:2px solid #000;text-align:right;width:20%;">Preis</th>
                            </tr>
                        </thead>
                        <tbody>${rows}</tbody>
                    </table>`;
            });

            host.innerHTML = `
                <div style="border-bottom:2px solid #000;padding-bottom:12px;margin-bottom:24px;">
                    <h1 style="margin:0;font-size:22pt;">Professionelle Preisliste</h1>
                    <p style="margin:6px 0 0;font-size:11pt;color:#333;">${escapeHtml(salon.replace(/_/g, ' '))}</p>
                    <p style="margin:4px 0 0;font-size:9pt;color:#666;">Powered by PreisExpert · ${dateIso}</p>
                </div>
                ${sectionsHtml}
            `;
            document.body.appendChild(host);

            await new Promise((r) => window.setTimeout(r, 80));

            const canvas = await html2canvas(host, {
                scale: 2,
                useCORS: true,
                logging: false,
                backgroundColor: '#ffffff',
                windowWidth: 794,
            });

            const pdf = new jsPDF('p', 'mm', 'a4');
            const pageWidth = pdf.internal.pageSize.getWidth();
            const pageHeight = pdf.internal.pageSize.getHeight();
            const margin = 12;
            const imgWidth = pageWidth - margin * 2;
            const imgHeight = (canvas.height * imgWidth) / Math.max(canvas.width, 1);
            const pageContentHeight = pageHeight - margin * 2;

            const imgData = canvas.toDataURL('image/jpeg', 0.93);
            let heightLeft = imgHeight;
            let position = margin;

            pdf.addImage(imgData, 'JPEG', margin, position, imgWidth, imgHeight);
            heightLeft -= pageContentHeight;

            while (heightLeft > 1) {
                position = margin - (imgHeight - heightLeft);
                pdf.addPage();
                pdf.addImage(imgData, 'JPEG', margin, position, imgWidth, imgHeight);
                heightLeft -= pageContentHeight;
            }

            pdf.save(`Preisliste_${salon}_${dateIso}.pdf`);
        } catch (err: any) {
            console.error('[Preisliste PDF]', err);
            alert('PDF konnte nicht gespeichert werden: ' + (err?.message || 'Unbekannter Fehler'));
        } finally {
            host.remove();
            setIsPdfSaving(false);
        }
    };

    const updatePreislistenEintrag = (id: string, data: Partial<PreislistenEintrag>) => {
        setClientData((prev: any) => ({
            ...prev,
            preisliste: (prev.preisliste || []).map((item: any) => 
                item.id === id ? { ...item, ...data } : item
            )
        }));
    };

    const removePreislistenEintrag = (id: string) => {
        setClientData((prev: any) => ({
            ...prev,
            preisliste: (prev.preisliste || []).filter((item: any) => item.id !== id)
        }));
    };

    const handleEditStart = (item: any) => {
        setEditingId(item.id);
        setEditForm(item);
        
        const mwst = (storeCalc.mwstSatz !== undefined && storeCalc.mwstSatz !== null ? Number(storeCalc.mwstSatz) : 19) / 100;
        const oldPrice = item.finalerPreis || 0;
        const oldNetto = oldPrice / (1 + mwst);
        const oldGewinn = item.gewinn || 0;
        
        const dPerc = oldNetto > 0 ? ((item.geräteEinsatz || 0) / oldNetto) : 0;
        const gk = storeCalc.gemeinkostenfaktor || 0;
        // Kanonisch: Anteil am Netto-Monatsumsatz (wie Selektor unprodUnternehmerlohnPercent)
        const ul = (storeCalc.unprodUnternehmerlohnPercent || 0) / 100;
        const vl = (storeCalc.settings?.global?.Verlust_1 || 0) / 100;
        
        const propRate = gk + ul + vl + dPerc;
        const nettoMultiplier = 1 - propRate;
        
        const fixedCosts = (oldNetto * nettoMultiplier) - oldGewinn;
        
        setEditMetrics({ nettoMultiplier, fixedCosts });
    };

    const handlePreisChange = (rawVal: string) => {
        const val = parseFloat(rawVal);
        if (isNaN(val)) {
            setEditForm(prev => ({ ...prev, finalerPreis: rawVal as any }));
            return;
        }
        const mwst = (storeCalc.mwstSatz !== undefined && storeCalc.mwstSatz !== null ? Number(storeCalc.mwstSatz) : 19) / 100;
        const netto = val / (1 + mwst);
        
        const neuerGewinn = (netto * editMetrics.nettoMultiplier) - editMetrics.fixedCosts;
        const neuerGewinnPercent = netto > 0 ? (neuerGewinn / netto) * 100 : 0;
        
        setEditForm(prev => ({
            ...prev,
            finalerPreis: val,
            gewinn: Math.round(neuerGewinn * 100) / 100,
            gewinnPercent: Math.round(neuerGewinnPercent * 10) / 10
        }));
    };

    const handleGewinnChange = (rawVal: string) => {
        const val = parseFloat(rawVal);
        if (isNaN(val)) {
            setEditForm(prev => ({ ...prev, gewinn: rawVal as any }));
            return;
        }
        const mwst = (storeCalc.mwstSatz !== undefined && storeCalc.mwstSatz !== null ? Number(storeCalc.mwstSatz) : 19) / 100;
        
        const netto = (val + editMetrics.fixedCosts) / editMetrics.nettoMultiplier;
        const neuerPreis = netto * (1 + mwst);
        const neuerGewinnPercent = netto > 0 ? (val / netto) * 100 : 0;
        
        setEditForm(prev => ({
            ...prev,
            gewinn: val,
            finalerPreis: Math.round(neuerPreis * 100) / 100,
            gewinnPercent: Math.round(neuerGewinnPercent * 10) / 10
        }));
    };

    const handleGewinnPercentChange = (rawVal: string) => {
        const val = parseFloat(rawVal);
        if (isNaN(val)) {
            setEditForm(prev => ({ ...prev, gewinnPercent: rawVal as any }));
            return;
        }
        const mwst = (storeCalc.mwstSatz !== undefined && storeCalc.mwstSatz !== null ? Number(storeCalc.mwstSatz) : 19) / 100;
        const safePercent = val >= 100 ? 99.9 : val; 
        
        const marginMultiplier = editMetrics.nettoMultiplier - (safePercent / 100);
        
        let netto = 0;
        if (marginMultiplier > 0.001) {
            netto = editMetrics.fixedCosts / marginMultiplier;
        } else {
            netto = editMetrics.fixedCosts / 0.001; 
        }
        
        const neuerGewinn = netto * (safePercent / 100);
        const neuerPreis = netto * (1 + mwst);
        
        setEditForm(prev => ({
            ...prev,
            gewinnPercent: val,
            gewinn: Math.round(neuerGewinn * 100) / 100,
            finalerPreis: Math.round(neuerPreis * 100) / 100
        }));
    };

    const handleEditSave = () => {
        if (editingId) {
            if (!editForm.name?.trim() || !editForm.kategorie?.trim()) {
                alert("Leistungsname und Kategorie dürfen nicht leer sein.");
                return;
            }
            const finalPreis = editForm.finalerPreis || 0;
            const zeit = editForm.bedienzeit || 0;
            const updatedProStunde = zeit > 0 ? (finalPreis / zeit) * 60 : 0;

            updatePreislistenEintrag(editingId, {
                ...editForm,
                preisProStunde: updatedProStunde
            });
            setEditingId(null);
        }
    };

    const handleDelete = (id: string) => {
        if (window.confirm('Eintrag wirklich löschen?')) {
            removePreislistenEintrag(id);
        }
    };

    const triggerAiAnalysis = async () => {
        if (preisliste.length === 0) {
            alert("Die Preisliste ist leer. Was soll die KI da prüfen?");
            return;
        }

        setIsAnalyzing(true);
        setAiReport(null);

        try {
            const functions = getFunctions(undefined, 'europe-west1');
            const analyzeFn = httpsCallable(functions, 'analyzePriceListAi');
            const preislisteGeprueft = preisliste.map((item: any) => {
                if (!item?.isPackage) return item;
                const checked = paketMitPruefung(item);
                return { ...item, gewinn: checked.pack.gewinn, gewinnPercent: checked.pack.gewinnPercent, packageServices: checked.services, materialEinsatz: checked.mat, geräteEinsatz: checked.dev };
            });
            const response = await analyzeFn({ preisliste: preislisteGeprueft });
            
            const resultData = response.data as any;
            if (resultData.success && resultData.report) {
                setAiReport(resultData.report);
            } else {
                throw new Error("Fehlerhaftes Format vom Server.");
            }
        } catch (error: any) {
            console.error("KI Error:", error);
            alert("Fehler bei der KI-Analyse: " + error.message);
        } finally {
            setIsAnalyzing(false);
        }
    };

    return (
        <div className="fixed inset-0 bg-stone-900/50 dark:bg-black/90 flex justify-center items-start z-[2147483647] pt-[140px] pb-8 px-4 sm:px-8 backdrop-blur-md font-sans">
            <Styles />
            
            <div id="preisliste-print-container" className="carbon-panel carbon-weave-bg w-full max-w-6xl relative" style={{ height: 'calc(100vh - 180px)' }}>
                <div className="carbon-content">
                    
                    <div className="no-print flex-shrink-0 p-6 sm:px-10 border-b border-pe-border dark:border-[#222] flex flex-col gap-4 bg-pe-sunken z-20 shadow-[0_5px_20px_rgba(0,0,0,0.8)] relative">
                        <h1 id="system-screen-title-pricing-master" className="text-2xl sm:text-3xl font-bold text-pe-accent-text tracking-widest uppercase drop-shadow-md">Salon Preisliste (Master)</h1>
                        <div className="flex flex-wrap gap-3 w-full">
                            <button
                                onClick={() => { void handleSavePdf(); }}
                                disabled={isPdfSaving}
                                className={`flex-1 sm:flex-none font-bold py-3 px-6 rounded-xl flex items-center justify-center gap-2 transition-all shadow-lg border uppercase tracking-widest text-xs ${isPdfSaving ? 'bg-emerald-100 dark:bg-emerald-900/40 text-stone-500 dark:text-gray-400 border-emerald-300 dark:border-emerald-900/50 cursor-not-allowed animate-pulse' : 'bg-emerald-600 hover:bg-emerald-500 text-black border-emerald-400'}`}
                            >
                                <span>⬇️</span> {isPdfSaving ? 'PDF wird erstellt…' : 'PDF herunterladen'}
                            </button>
                            <button onClick={() => window.print()} className="flex-1 sm:flex-none bg-pe-tile-header text-blue-700 dark:text-blue-400 border border-pe-border dark:border-[#222] hover:border-blue-500 hover:text-blue-800 dark:hover:text-blue-300 font-bold py-3 px-6 rounded-xl flex items-center justify-center gap-2 transition-all shadow-inner uppercase tracking-widest text-xs hover:shadow-[0_0_15px_rgba(59,130,246,0.3)]">
                                <span>🖨️</span> Drucken / Vorschau
                            </button>
                            <button 
                                onClick={triggerAiAnalysis} 
                                disabled={isAnalyzing}
                                className={`flex-1 sm:flex-none font-bold py-3 px-6 rounded-xl flex items-center justify-center gap-2 transition-all shadow-inner border uppercase tracking-widest text-xs ${isAnalyzing ? 'bg-pe-tile-header text-stone-500 dark:text-gray-500 border-pe-border-strong cursor-not-allowed animate-pulse' : 'bg-pe-tile-header text-fuchsia-700 dark:text-fuchsia-400 border-pe-border dark:border-[#222] hover:border-fuchsia-500 hover:text-fuchsia-800 dark:hover:text-fuchsia-300 hover:shadow-[0_0_15px_rgba(192,38,211,0.3)]'}`}
                            >
                                <span>🤖</span> {isAnalyzing ? 'Prüfung läuft...' : 'KI-Prüfung'}
                            </button>
                            <button onClick={onClose} className="flex-1 sm:flex-none bg-pe-tile-header text-red-600 dark:text-red-400 border border-pe-border dark:border-[#222] hover:border-red-500 hover:text-red-800 dark:hover:text-red-300 font-bold py-3 px-6 rounded-xl flex items-center justify-center gap-2 transition-all shadow-inner uppercase tracking-widest text-xs hover:shadow-[0_0_15px_rgba(239,68,68,0.3)]">
                                <span>✖</span> Schließen
                            </button>
                        </div>
                    </div>

                    <div className="print-scroll-area flex-grow overflow-y-auto p-6 sm:p-10 scroll-smooth relative z-10">
                        
                        <h1 className="print-title hidden text-center text-3xl font-bold mb-6 tracking-widest">PREISLISTE</h1>

                        <datalist id="kategorie-vorschlaege">
                            <option value="Damen" />
                            <option value="Herren" />
                            <option value="Farbe" />
                            <option value="Strähnen" />
                            <option value="Kosmetik" />
                            <option value="Dauerwelle" />
                            <option value="Spezial" />
                        </datalist>

                        {aiReport && (
                            <div className="no-print bg-pe-tile-header border border-fuchsia-900/50 rounded-xl p-6 mb-10 shadow-[inset_0_2px_15px_rgba(0,0,0,0.8)] animate-fade-in">
                                <h3 className="text-2xl font-bold text-fuchsia-700 dark:text-fuchsia-400 mb-2 flex items-center gap-3">
                                    <span>🤖</span> KI-Diagnose Report
                                </h3>
                                <p className="text-pe-muted dark:text-gray-300 text-lg mb-6 border-b border-pe-border dark:border-[#222] pb-4">{aiReport.summary}</p>
                                
                                <div className="space-y-4">
                                    {aiReport.findings.map((finding, idx) => {
                                        let colors = "bg-pe-card border-pe-border-strong text-pe-muted dark:text-gray-300";
                                        let icon = "ℹ️";
                                        
                                        if(finding.type === 'error') {
                                            colors = "bg-red-950/30 border-red-900/50 text-red-200";
                                            icon = "🚨";
                                        } else if (finding.type === 'warning') {
                                            colors = "bg-yellow-950/30 border-yellow-900/50 text-yellow-200";
                                            icon = "⚠️";
                                        } else if (finding.type === 'success') {
                                            colors = "bg-green-950/30 border-green-900/50 text-green-200";
                                            icon = "✅";
                                        }

                                        return (
                                            <div key={idx} className={`p-5 rounded-xl border shadow-inner ${colors}`}>
                                                <h4 className="font-bold text-lg mb-1 flex items-center gap-2">
                                                    <span>{icon}</span> {finding.title}
                                                </h4>
                                                <p className="text-sm opacity-90 ml-8">{finding.message}</p>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        <div className="print-header-branding hidden text-black print:block">
                            <div className="flex justify-between items-center gap-6">
                                <div className="text-left">
                                    <h1 className="font-bold text-2xl">Professionelle Preisliste</h1>
                                    <p className="text-xs text-gray-700">Powered by PreisExpert - we help hairdressers...</p>
                                </div>
                            </div>
                        </div>

                        {Object.keys(groupedPreisliste).length === 0 ? (
                            <div className="text-center text-pe-muted dark:text-gray-400 mt-20 no-print">
                                <p className="text-xl font-bold uppercase tracking-widest">Die Preisliste ist noch leer.</p>
                                <p className="text-sm mt-3 opacity-70">Kalkuliere eine Leistung und klicke auf "In Preisliste aufnehmen".</p>
                            </div>
                        ) : (
                            Object.entries(groupedPreisliste).map(([kategorie, items]) => (
                                <div key={kategorie} className="mb-10">
                                    <h2 className="text-lg font-bold text-pe-accent-text uppercase tracking-widest bg-pe-sunken p-4 rounded-t-xl border-t border-x border-pe-border dark:border-[#222] shadow-inner no-print">{kategorie}</h2>
                                    <h2 className="print-category hidden">{kategorie}</h2>
                                    
                                    <div className="border border-pe-border dark:border-[#222] rounded-b-xl overflow-hidden bg-pe-tile-header shadow-[inset_0_2px_10px_rgba(0,0,0,0.5)]">
                                        <table className="print-table w-full text-left text-sm sm:text-base border-collapse">
                                            <thead>
                                                <tr className="bg-pe-card text-stone-500 dark:text-gray-500 uppercase tracking-widest text-xs border-b border-pe-border dark:border-[#222] no-print">
                                                    <th className="p-4 w-[22%] font-bold text-left sticky top-0 bg-[#EDEAE6]/95 dark:bg-[#111]/95 backdrop-blur-md z-10">Leistung & Details</th>
                                                    <th className="p-4 text-center w-[13%] font-bold sticky top-0 bg-[#EDEAE6]/95 dark:bg-[#111]/95 backdrop-blur-md z-10">Zeit</th>
                                                    <th className="p-4 text-right w-[20%] font-bold sticky top-0 bg-[#EDEAE6]/95 dark:bg-[#111]/95 backdrop-blur-md z-10">Kosten (Mat/Geräte)</th>
                                                    <th className="p-4 text-right w-[20%] text-blue-700 dark:text-blue-400 font-bold sticky top-0 bg-[#EDEAE6]/95 dark:bg-[#111]/95 backdrop-blur-md z-10">Rücklage (KI-Metrik)</th>
                                                    <th className="p-4 text-right w-[15%] font-bold sticky top-0 bg-[#EDEAE6]/95 dark:bg-[#111]/95 backdrop-blur-md z-10">Preis</th>
                                                    <th className="p-4 text-center w-[10%] font-bold sticky top-0 bg-[#EDEAE6]/95 dark:bg-[#111]/95 backdrop-blur-md z-10">Aktion</th>
                                                </tr>
                                                <tr className="print-only hidden font-bold border-b-2 border-black">
                                                    <th className="p-2 print-col-1">Leistung</th>
                                                    <th className="p-2 print-col-2">Zeit</th>
                                                    <th className="p-2 print-col-3">Preis</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {items.map((item: any) => {
                                                    const isEditing = editingId === item.id;
                                                    const checked = item.isPackage ? paketMitPruefung(item) : null;

                                                    return (
                                                        <React.Fragment key={item.id}>
                                                        <tr className="border-b border-pe-border dark:border-[#1a1a1a] hover:bg-pe-hover dark:hover:bg-white/5 transition-colors group last:border-0">
                                                            
                                                            <td className="p-4 print-col-1">
                                                                {isEditing ? (
                                                                    <div className="flex flex-col gap-3">
                                                                        <input type="text" value={editForm.name || ''} onChange={e => setEditForm({...editForm, name: e.target.value})} onFocus={e => e.target.select()} placeholder="Leistungsname" className="w-full bg-pe-input dark:bg-[#000] text-pe-text p-3 rounded-lg border border-pe-border-strong focus:border-[#E6C299] outline-none shadow-inner" />
                                                                        <input type="text" list="kategorie-vorschlaege" value={editForm.kategorie || ''} onChange={e => setEditForm({...editForm, kategorie: e.target.value})} onFocus={e => e.target.select()} placeholder="Kategorie ändern..." className="w-full bg-pe-input dark:bg-[#000] text-pe-muted dark:text-gray-300 p-3 rounded-lg border border-pe-border-strong focus:border-[#E6C299] outline-none text-xs shadow-inner" />
                                                                        <input type="text" value={editForm.materialBeschreibung || ''} onChange={e => setEditForm({...editForm, materialBeschreibung: e.target.value})} onFocus={e => e.target.select()} placeholder="Material-Label (Druck)" className="w-full bg-yellow-950/20 text-yellow-700 dark:text-yellow-500 p-3 rounded-lg border border-yellow-900/50 focus:border-yellow-500 outline-none text-sm shadow-inner" />
                                                                        <input type="text" value={editForm.geräteBeschreibung || ''} onChange={e => setEditForm({...editForm, geräteBeschreibung: e.target.value})} onFocus={e => e.target.select()} placeholder="Geräte-Label (Druck)" className="w-full bg-blue-950/20 text-blue-700 dark:text-blue-400 p-3 rounded-lg border border-blue-900/50 focus:border-blue-500 outline-none text-sm shadow-inner" />
                                                                    </div>
                                                                ) : (
                                                                    <div>
                                                                        <div className="font-bold text-pe-muted dark:text-gray-300 print:text-black flex flex-wrap items-center gap-2">
                                                                            <span>{item.name}</span>
                                                                            {item.isPackage && (
                                                                                <span className="text-[10px] font-black uppercase tracking-widest px-1.5 py-0.5 rounded border border-[#E6C299] text-[#E6C299] print:text-black print:border-black">Paket</span>
                                                                            )}
                                                                        </div>
                                                                        {item.isPackage && (
                                                                            <div className="text-xs text-pe-muted dark:text-gray-400 mt-1 print:text-black">
                                                                                {formatMinutes(item.gesamtDauerMinuten || item.bedienzeit)} Min.
                                                                                {Array.isArray(item.packageServices) && item.packageServices.length > 0 && (
                                                                                    <button
                                                                                        type="button"
                                                                                        className="no-print ml-2 underline text-customBeige"
                                                                                        onClick={() => setOpenPackageId(openPackageId === item.id ? null : item.id)}
                                                                                    >
                                                                                        {openPackageId === item.id ? 'Zuklappen' : 'Teilleistungen'}
                                                                                    </button>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                        {item.materialBeschreibung && <div className="text-sm text-yellow-600/80 mt-1 print:hidden tracking-wide font-medium">inkl. {item.materialBeschreibung}</div>}
                                                                        {item.geräteBeschreibung && <div className="text-sm text-blue-500/80 mt-1 print:hidden tracking-wide font-medium">inkl. {item.geräteBeschreibung}</div>}
                                                                    </div>
                                                                )}
                                                            </td>

                                                            <td className="p-4 text-center print-col-2">
                                                                {isEditing ? (
                                                                    <input type="number" value={editForm.bedienzeit || 0} onChange={e => setEditForm({...editForm, bedienzeit: Number(e.target.value)})} onFocus={e => e.target.select()} className="w-20 bg-pe-input dark:bg-[#000] text-pe-text p-3 rounded-lg border border-pe-border-strong focus:border-[#E6C299] text-center outline-none mx-auto block font-numeric shadow-inner" />
                                                                ) : (
                                                                    <span className="text-pe-muted dark:text-gray-400 font-numeric print:text-black">{formatMinutes(item.bedienzeit)} Min.</span>
                                                                )}
                                                            </td>

                                                            <td className="p-4 text-right no-print font-numeric">
                                                                {isEditing ? (
                                                                    <div className="flex flex-col gap-3 items-end">
                                                                        <input type="number" value={editForm.materialMenge ?? 0} onChange={e => setEditForm({...editForm, materialMenge: Number(e.target.value)})} onFocus={e => e.target.select()} placeholder="Gramm" className="w-20 bg-pe-input dark:bg-[#000] text-yellow-700 dark:text-yellow-500 p-2 rounded-lg border border-pe-border-strong focus:border-[#E6C299] text-right text-sm shadow-inner" />
                                                                        <input type="number" value={editForm.geräteEinsatz ?? 0} onChange={e => setEditForm({...editForm, geräteEinsatz: Number(e.target.value)})} onFocus={e => e.target.select()} placeholder={`Gerät ${currencyCode}`} className="w-20 bg-pe-input dark:bg-[#000] text-blue-700 dark:text-blue-400 p-2 rounded-lg border border-pe-border-strong focus:border-[#E6C299] text-right text-sm shadow-inner" />
                                                                    </div>
                                                                ) : (
                                                                    <MaterialAnzeige
                                                                        grams={item.isPackage ? checked.gramm : item.materialMenge}
                                                                        mat={item.isPackage ? checked.mat : item.materialEinsatz}
                                                                        dev={item.isPackage ? checked.dev : item.geräteEinsatz}
                                                                        formatCurrency={formatCurrency}
                                                                        mengeLabel={item.isPackage ? 'Gesamtmenge' : 'Menge'}
                                                                    />
                                                                )}
                                                            </td>

                                                            <td className="p-4 text-right bg-stone-100/50 dark:bg-[#0a0a0a]/50 border-l border-r border-pe-border dark:border-[#222] no-print font-numeric">
                                                                {isEditing ? (
                                                                    <div className="flex flex-col gap-3 items-end">
                                                                        <div className="flex items-center gap-2">
                                                                            <span className="text-xs text-blue-700 dark:text-blue-400 font-bold w-8">KI %</span>
                                                                            <input type="number" step="any" value={editForm.gewinnPercent ?? ''} onChange={e => handleGewinnPercentChange(e.target.value)} onFocus={e => e.target.select()} className="w-20 bg-pe-input dark:bg-[#000] text-blue-700 dark:text-blue-400 p-2 rounded-lg border border-pe-border-strong focus:border-blue-400 text-right text-sm outline-none shadow-inner" />
                                                                        </div>
                                                                        <div className="flex items-center gap-2">
                                                                            <span className="text-xs text-green-700 dark:text-green-400 font-bold w-8">KI {currencyCode}</span>
                                                                            <input type="number" step="any" value={editForm.gewinn ?? ''} onChange={e => handleGewinnChange(e.target.value)} onFocus={e => e.target.select()} className="w-20 bg-pe-input dark:bg-[#000] text-green-700 dark:text-green-400 p-2 rounded-lg border border-pe-border-strong focus:border-green-400 text-right text-sm outline-none shadow-inner" />
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <RuecklageAnzeige
                                                                        pct={item.isPackage ? checked.pack.gewinnPercent : item.gewinnPercent}
                                                                        betrag={item.isPackage ? checked.pack.gewinn : item.gewinn}
                                                                        formatCurrency={formatCurrency}
                                                                    />
                                                                )}
                                                            </td>

                                                            <td className="p-4 text-right font-bold text-pe-accent-text print:text-black print-col-3 font-numeric">
                                                                {isEditing ? (
                                                                    <input type="number" step="any" value={editForm.finalerPreis ?? ''} onChange={e => handlePreisChange(e.target.value)} onFocus={e => e.target.select()} className="w-24 bg-pe-input dark:bg-[#000] text-pe-text p-3 rounded-lg border border-pe-border-strong focus:border-[#E6C299] text-right outline-none ml-auto block font-numeric shadow-inner" />
                                                                ) : (
                                                                    formatCurrency(item.finalerPreis)
                                                                )}
                                                                {!isEditing && item.preisProStunde > 0 && (
                                                                    <div className="text-xs text-stone-500 dark:text-gray-500 font-medium mt-1.5 no-print tracking-wide">
                                                                        ({formatCurrency(item.preisProStunde)}/h)
                                                                    </div>
                                                                )}
                                                            </td>

                                                            <td className="p-4 text-center no-print">
                                                                {isEditing ? (
                                                                    <div className="flex justify-center gap-4">
                                                                        <button onClick={handleEditSave} className="text-green-500 hover:text-green-700 dark:text-green-400 font-bold text-xl drop-shadow-md hover:scale-110 transition-transform" title="Speichern">✔</button>
                                                                        <button onClick={() => setEditingId(null)} className="text-stone-500 dark:text-gray-500 hover:text-red-600 dark:text-red-400 font-bold text-xl drop-shadow-md hover:scale-110 transition-transform" title="Abbrechen">✖</button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="flex justify-center gap-4 opacity-0 group-hover:opacity-100 transition-opacity">
                                                                        <button onClick={() => handleEditStart(item)} className="text-blue-500 hover:text-blue-700 dark:text-blue-400 text-xl drop-shadow-md hover:scale-110 transition-transform" title="Bearbeiten">✏️</button>
                                                                        <button onClick={() => handleDelete(item.id)} className="text-red-600 hover:text-red-500 text-xl drop-shadow-md hover:scale-110 transition-transform" title="Löschen">🗑️</button>
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                        {!isEditing && checked && openPackageId === item.id && (
                                                            <tr className="no-print">
                                                                <td colSpan={6} className="px-4 pt-0 pb-3">
                                                                    <div className="ml-1 border-l border-[#E6C299]/40 pl-3 space-y-0.5">
                                                                        {checked.services.map((s: any) => (
                                                                            <div key={s.id} className="grid grid-cols-[minmax(0,1.4fr)_4.2rem_4.6rem_auto_3.2rem_4.8rem] gap-x-3 items-baseline text-xs py-0.5 text-pe-muted dark:text-gray-400">
                                                                                <span className="truncate text-pe-text/90">{s.name}</span>
                                                                                <span className="text-right font-numeric">{formatMinutes(s.dauerMinuten)} Min.</span>
                                                                                <span className="text-right font-numeric text-yellow-700/90 dark:text-yellow-500/80">
                                                                                    {(Number(s.materialMenge) || 0) > 0 ? `${Number(s.materialMenge)} g` : ''}
                                                                                </span>
                                                                                <span className="text-right font-numeric text-yellow-700/90 dark:text-yellow-500/80">Mat. {formatCurrency(s.materialKostenNetto || 0)}</span>
                                                                                <span className="text-right font-numeric">{Number(s.gewinnPercent || 0).toFixed(1)}%</span>
                                                                                <span className="text-right font-numeric">{formatCurrency(s.einzelpreisBrutto)}</span>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                        </React.Fragment>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}